export default defineNuxtPlugin(() => {
  const config = {
    imageUrl: useRuntimeConfig().public.strapi.url
  };

  return {
    provide: {
      siteConfig: config,
    },
  };
});